import React from "react";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RedirectToMonitoring = (props: any) => {
    const history = useHistory();
    const { t: tLang } = useTranslation();
    const handleRedirect = (e: any, RedirectLink: string) => {
        e.preventDefault();
        history.push(RedirectLink);
        props.closeDialog();
    };

    const closeDialog = () => {
        props.closeDialog();
    };

    return (
        <>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="user" />
                </div>
                <h1>{tLang("manageAccount.myAccount.membershipInformation.dialog.redirectToMonitoring.title")}</h1>
            </div>
            <div className="dialog-body">
                <div className="row">
                    <p>{tLang("manageAccount.myAccount.membershipInformation.dialog.redirectToMonitoring.content")}</p>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                            <span className="btn-text">{tLang("manageAccount.myAccount.membershipInformation.dialog.redirectToMonitoring.cancelBtnText")}</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            onClick={(e: any) => {
                                handleRedirect(e, "/identity-vault");
                            }}
                        >
                            <span className="btn-text">{tLang("manageAccount.myAccount.membershipInformation.dialog.redirectToMonitoring.submitBtnText")}</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RedirectToMonitoring;
